<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :showList="true"
            :cols="cols"
            @click:row="setItem"
            api-url="main/store/all"
            :show-submit-and-clear-btn="false"
            :show-list-btn="false"
            :canDelete="item.id >= 1"
            :items="items"
            :canSubmit="canSubmit"
            :isEditing.sync="isEditing"
            :show-navigation-btns="false"
            @submit="submit"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="CurrencyForm"
        >
          <template>
            <v-row>
              <v-col col="12">
                <v-autocomplete
                    :menu-props="{ bottom: true, offsetY: true }"
                    class="rounded-lg"
                    :items="code_types"
                    v-model="item.code"
                    label="نوع"
                    item-text="text"
                    :disabled="!isEditing"
                    item-value="value"
                    v-bind="$attrs"
                    clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <v-text-field label="* نام انبار "
                              v-model="item.name" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <user-select
                  user-type="stke"
                  class="rounded-lg"
                  label="انباردار"
                  v-model="item.storekeeper"
                  :disabled="!isEditing"
                >
                </user-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <v-textarea label="* آدرس انبار " rows="2"
                            v-model="item.address" background-color="white" class="rounded-lg"
                            :disabled="!isEditing"/>

              </v-col>
            </v-row>
            <v-row>
            </v-row>

          </template>
        </m-form>

      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import UserSelect from "@/components/selects/UserSelect";


export default {
  name: "StoreForm",
  components: {UserSelect},
  mixins: [MFormMixin,  formsMixin, FormsMixin],
  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'main/store/all',
      baseUrl: "main/store",
      permissionBasename: "store",
      appendSlash: false,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      storekeepers: [],
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      items: [],
      code_types: [
        {text: 'انبار مرکزی', value: 'central'},
        {text: 'واحد پردازش سفارشات', value: 'packing'},
        {text: 'انبار', value: 'other'},
      ],
      first: false,
      cols: [
        {
          text: "نام",
          value: "name",
        },
        {
          text: "انباردار",
          value: "storekeeper_name",
        },
        {
          text: "نوع",
          value: "code",
          type: "select",
          items: [
            {text: 'انبار مرکزی', value: 'central'},
            {text: 'واحد پردازش سفارشات', value: 'packing'},
            {text: 'انبار', value: 'other'},

          ]
        },
      ],

    };
  },
  computed: {
    title(){
      return 'انبار'
    },
    headers() {
      return [];
    },
  },
  updated() {
  },
  created() {
    this.getStorekeepers()
  },
  methods: {
    getStorekeepers() {
      this.request({
        url: this.endpoint(`main/storekeeper/all`),
        method: "get",
        success: data => {
          this.storekeepers = []
          for (let storekeeper of data) {
            this.storekeepers.push({
              'name': storekeeper.name ,
              'id': storekeeper.id,
            })
          }
        }
      })
    }
  },
}
</script>

<style scoped lang="scss"></style>

